import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from '../../../utils/getTranslation';
import { ProfileAvatar } from './ProfileAvatar';
import { UserContext } from './../../../providers/user.provider';
import { getAdminProfileId } from '../redux/profile.selectors';
import {
  SET_DISPLAY_PROFILE_MODAL,
  SET_PROFILE_LAYOUT_TYPE,
} from '../redux/profile.types';
import { set } from 'utils/LocalStorageUtil';
import { AddProfileButton } from './AddProfileButton.js';
import { ProfilesHeader } from './ProfilesHeader';
import { GenericButton } from 'components/GenericButton';
import { getUserIsKids } from 'utils/User';
import useHandleUserProvider from 'context/hooks/useHandleUserProvider';
import { useKidProfile } from '../hooks/useKidProfile';

export const SelectProfileView = () => {
  const dispatch = useDispatch();
  const { changeProfile } = useContext(UserContext);
  const adminUserId = useSelector(getAdminProfileId);
  const translations = useSelector(state => state.translations);
  const { profilesInfo } = useSelector(state => state.profilesManager);
  const { gamification_id: gamification_id_current_usr } = useSelector(state => state.user);
  const isKids  = getUserIsKids();
  const maxAvatarsClass = profilesInfo.members?.length >= 4 ? 'max-avatars' : ''
 const { handlerChangeProfile } = useKidProfile()

  const handleProfileSelect = (userHash, gamification_id) => {
    set('selectProfile', { enable: true });
    handlerChangeProfile(userHash, profilesInfo, adminUserId, gamification_id, gamification_id_current_usr  );
    if(gamification_id_current_usr === gamification_id){
      dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: false });
      return;
    }
    dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: false });
  };

  const handleChangeView = () => {
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'MANAGE_PROFILES' });
  };

  return (
    <>
      <ProfilesHeader />
      <section className="select-profile-view profiles-common__container fade__in">
        <h2 className="select-profile-view__title profiles-common__container__title">
          {getTranslation('listProfiles_access_title_label', translations)}
        </h2>
        <div className={`select-profile-view__profiles profiles-common__container__avatars fade__in ${maxAvatarsClass}`}>
          {profilesInfo?.members?.map(profile => (
            <ProfileAvatar
              key={`select-profile-key-${profile.partnerUserId}`}
              avatarSrc={profile?.user_image}
              profileName={profile?.username}
              onClick={() => handleProfileSelect(profile?.user_hash, profile?.gamification_id )}
            />
          ))}
          {(profilesInfo.members?.length < profilesInfo.maxMembers && !isKids) && (
            <AddProfileButton />
          )}
        </div>
        {!isKids && (
          <GenericButton
            textContent={getTranslation(
              'listProfiles_access_option_button_manageProfiles',
              translations,
            )}
            onClick={handleChangeView}
            classNames={['select-profile-view__manage-button']}
          />
        )}
      </section>
    </>
  );
};
